import api from './api';

// Anket sonuç raporu (spec 2026-10-15 §9; 2026-10-16 E1). Rapor ve ayar yalnız Anketler (SV) modülü ister; anlatı/AI uçları
// AI+ ister (kapalıysa 403 survey.aiPlusRequired). Yapı uçları sunucuda kalır, ön yüz KULLANMAZ (yapı yayında kurulur).
export const getSurveyReport = (id) => api.get(`/v1/surveys/${id}/report`);
export const saveReportSettings = (id, data) => api.put(`/v1/surveys/${id}/report/settings`, data);
export const regenerateNarrative = (id, language) => api.post(`/v1/surveys/${id}/report/narrative/regenerate`, { language });
export const getNarrativeJob = (id) => api.get(`/v1/surveys/${id}/report/narrative/job`);
export const saveNarrative = (id, data) => api.put(`/v1/surveys/${id}/report/narrative`, data);
export const publishNarrative = (id) => api.post(`/v1/surveys/${id}/report/narrative/publish`);
export const unpublishNarrative = (id) => api.post(`/v1/surveys/${id}/report/narrative/unpublish`);
export const getSurveyTemplates = (language) => api.get('/v1/survey-templates', { params: { language } });
export const createSurveyFromTemplate = (data) => api.post('/v1/surveys/from-template', data);
